<template>
  <div class="home">
    <div class="devicestatus">
      
    </div>
    <!-- 拥有学生卡 -->
    <div v-show="isCard">
      <div id="container" class="container"></div>
      <div class="operat">
        <!-- 定位按钮 -->
        <i class="iconfont icon-dingwei1" @click="handlePosition"></i>
        <!-- 历史轨迹按钮 -->
        <i class="iconfont icon-lishiguiji" @click="handleTrack"></i>
        <!-- 围栏按钮 -->
        <i class="iconfont icon-weilan-" @click="handleFence"></i>
      </div>
    </div>

    <!-- 未拥有学生卡 -->
    <div v-show="!isCard">
      <van-empty image="error" description="暂未拥有学生卡,请联系学校购买">
        <van-button class="button" size="small" type="primary" round @click="hrefStudent">
          更换学生
        </van-button>
        <div class="top"></div>
        <van-button class="button" size="small" round >注销登录</van-button>
      </van-empty>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {Toast} from 'vant'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      isCard: true, // 是否拥有学生卡
      studentInfo:{},
      address: '',
      map: null,
      studentInfo: {},
      mapInfo: {}
    }
  },
  computed: mapState('user', ['studnetData']),
  mounted() {
    // 获取学生数据
    // await this.getStudnetData()
    // const studentObj = this.studnetData.result.data
    // 未拥有学生卡
    // if (!studentObj.length) {
    //   this.isCard = false
    //   return
    // }
    // 执行定位
    // this.studentObj = studentObj[0]
    // this.handlePosition()
   
    this.initMap();
    this.getStudentlist();
    
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log(to.name)
  //   if (to.name != 'student' && to.name !== 'login' && !this.isCard) {
  //     next(false)
  //   } else {
  //     next()
  //   }
  // },
  methods: {
    getStudentlist:function(){
       var s_curchild = localStorage.getItem("currentChild");
       
      if (s_curchild==undefined || s_curchild==null){
        this.getChildlist()
      }else{
        var curchild=JSON.parse(s_curchild)
        this.studentInfo= curchild
        //alert(this.$route.query.newsession)
        if (this.$route.query.newsession=="true"){
          //alert("ok")
          this.$http
          .json_post(this.$api.baseinfo.getchildinfo, {
            Studentid:eval(curchild.Studentid)
          })
          .then(data => {
            if (data.code == 0) {
              
              localStorage.setItem('currentChild',JSON.stringify(data.data))
              var sinfo = localStorage.getItem("currentChild");
              this.studnetInfo = JSON.parse(sinfo);
              if (this.studentInfo.Deviceid==""){
                this.$toast("未绑定设备");
                this.$router.push("/my");
              }else {
                this.handlePosition();
              }
            }else{
              localStorage.removeItem('currentChild')
              //Toast(data.msg);
              this.getChildlist()
              return
            }

          })
        }else {
          if (this.studentInfo.Deviceid==""){
          this.$toast("未绑定设备");
          this.$router.push("/my");
          }else {
            this.handlePosition();
          }
        }
        
        
      }
    

    },
    getChildlist:function(){
      this.$http
          .json_post(this.$api.baseinfo.getchildlist, {
          
          })
          .then(data => {
          
            console.log("data",data);
            if (data.code===0){
              if(data.data.length==0){
                this.$toast("未绑定小孩")
               
                this.$router.push("/studentinfo");
                return;
              }
              localStorage.setItem("currentChild",JSON.stringify(data.data[0]));
              console.log(data.data[0])
              this.studentInfo = data.data[0];
              if (this.studentInfo.Deviceid=="") {
                this.$toast("未绑定设备");
                this.$router.push("/my");
              }else{
                this.handlePosition();
              }

            } else if (data.code==2){
                this.$router.push("/studentinfo");
                return;
            }else {
              Toast(data.msg);
            }
          })
          .catch(err=>{
            //alert(JSON.stringify(err))
            
          })
    },
    // 跳转 选择学生页面
    hrefStudent() {
      this.$router.push({
        name: 'student',
        query: { studentId: localStorage.getItem('studentId') }
      })
    },

    initMap() {
     
      var container = document.getElementById('container')
      this.map = new window.AMap.Map('container', {
        resizeEnable: true,
        zoom: 14,
        //center: [this.mapInfo.Lon, this.mapInfo.Lat]
      })
      this.regeoCode()
    },

    addMarker() {
      this.map.clearMap()
      var marker = new window.AMap.Marker({
        map: this.map,
        position: [this.mapInfo.Lon, this.mapInfo.Lat],
        center: [this.mapInfo.Lon, this.mapInfo.Lat]
      })

      var title = '孩子的位置',
        content = []
      // 获取当前之间减后台更新时间
      //alert(this.$publicFn.dateFormat(this.mapInfo.Ts*1000))
      //content.push(`日期:  ${new Date(this.mapInfo.Ts*1000).toLocaleString()}`)
      content.push(`日期:  ${this.$publicFn.dateFormat(this.mapInfo.Ts*1000)}`)
      content.push(`地址：${this.address}`)
      var infoWindow = new window.AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: this.createInfoWindow(title, content.join('<br/>')),
        offset: new window.AMap.Pixel(16, -45)
      })

      infoWindow.open(this.map, [this.mapInfo.Lon, this.mapInfo.Lat])
      this.map.setFitView();
      //鼠标点击marker弹出自定义的信息窗体
      window.AMap.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, [this.mapInfo.Lon, this.mapInfo.Lat])
      })
    },

    createInfoWindow(title, content) {
      var info = document.createElement('div')
      info.className = 'custom-info input-card content-window-card'

      //可以通过下面的方式修改自定义窗体的宽高
      //info.style.width = "400px";
      // 定义顶部标题
      var top = document.createElement('div')
      var titleD = document.createElement('div')
      var closeX = document.createElement('img')
      top.className = 'info-top'
      titleD.innerHTML = title
      closeX.src = 'https://webapi.amap.com/images/close2.gif'
      closeX.onclick = this.closeInfoWindow

      top.appendChild(titleD)
      top.appendChild(closeX)
      info.appendChild(top)

      // 定义中部内容
      var middle = document.createElement('div')
      middle.className = 'info-middle'
      middle.style.backgroundColor = 'white'
      middle.innerHTML = content
      info.appendChild(middle)

      // 定义底部内容
      var bottom = document.createElement('div')
      bottom.className = 'info-bottom'
      bottom.style.position = 'relative'
      bottom.style.top = '0px'
      bottom.style.margin = '0 auto'
      var sharp = document.createElement('img')
      sharp.src = 'https://webapi.amap.com/images/sharp.png'
      bottom.appendChild(sharp)
      info.appendChild(bottom)
      return info
    },

    regeoCode() {
      var geocoder = new window.AMap.Geocoder({
        city: '010', //城市设为北京，默认：“全国”
        radius: 1000 //范围，默认：500
      })
    
      geocoder.getAddress([this.mapInfo.Lon, this.mapInfo.Lat], (status, result) => {
        if (status === 'complete' && result.regeocode) {
     
          var address = result.regeocode.formattedAddress
          this.address = address
          this.addMarker()

          // document.getElementById('address').value = address
        } else {
          //alert('根据经纬度查询地址失败')
          this.addMarker()
        }
      })
    },

    closeInfoWindow() {
      this.map.clearInfoWindow()
    },

    // 定位
    handlePosition() {
      const toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在定位'
      })
      setTimeout(() => {
        toast.clear()
      }, 1000 * 6)
      this.$http
        .json_post(this.$api.studentcard.getlastgps, {
         Deviceid:this.studentInfo.Deviceid
        })
        .then(data => {
          if (data.code == 0) {
            toast.clear()
            if (data.data.Code==0){
              this.mapInfo = data.data.Data
              this.initMap()
            }else {
            toast.clear()
            this.$toast('暂未获取到定位信息~')
          }
          } else {
            toast.clear()
            this.$toast('请稍后重试~')
          }
        })
        .catch(err => {
          toast.clear()
          this.$toast('暂未获取到定位信息')
        })
    },

    handleFence() {
      this.$router.push({ name: 'fence' })
    },
    handleTrack() {
      this.$router.push({ name: 'track' })
    }
  }
}
</script>

<style lang="scss" scoped>
.home,
#container {
  width: 100%;
  height: calc(100vh - 50px);
}
.devicestatus {
  border-radius: 15px;
  height:80px;
  width: 60%;
  position: absolute;
  top:30px;
  background-color:rgba(198, 191, 191, 0.4);
}
.operat {
  position: fixed;
  bottom: 100px;

  right: 15px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  i {
    width: 50px;
    height: 50px;
    font-size: 18px;
    margin-top: 15px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    background: #40e0d0; /* fallback for old browsers */
    background: -webkit-linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    &.icon-dingwei1 {
      font-size: 22px;
    }
  }
}
</style>
